<app-pane title="Results Config">
  <div class="tab-header">
    <button id="scalar-button" class="tab-button" (click)="tabButtonClicked('scalar')">Scalar</button>
    <button id="vector-button" class="tab-button" (click)="tabButtonClicked('vector')">Vector</button>
  </div>

  <div id="scalar" class="tab-content">
    <div class="table">
      <div *ngFor="let result of scalarResults" class="row">
        <div class="label-cell">{{result.name}}</div>
        <div class="control-cell"><input type="checkbox" [checked]="result.id === modelScalarId" (change)="modelScalarChanged($event, result.id)" /></div>
      </div>
    </div>
  </div>

  <div id="vector" class="tab-content">
    <div class="table">
      <div *ngFor="let result of vectorResults" class="row">
        <div class="label-cell">{{result.name}}</div>
        <div class="control-cell"><input type="checkbox" [checked]="result.id === modelVectorId" (change)="modelVectorChanged($event, result.id)" /></div>
      </div>
    </div>
  </div>
</app-pane>
